import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import SearchIcon from "@/assets/images/common/mobile-search.png";
import CloseMobileNavIcon from "@/assets/svg/close-mobile-nav.svg";
import MobileLogo from "@/assets/svg/mobile-logo.svg";
import MobileNavContactUsIcon from "@/assets/svg/mobile-nav-contact-us.svg";
import MobileNavEmailUsIcon from "@/assets/svg/mobile-nav-email-us.svg";
import MobileNavFindAStoreIcon from "@/assets/svg/mobile-nav-find-a-store.svg";
import MobileNavWishListIcon from "@/assets/svg/mobile-nav-wish-list.svg";
import { MobileMenuList } from "@/components/business/header";
import { toast } from "@/components/pop-ui/pop-toast";
import { QuickChatWrapper } from "@/components/pop-ui/quick-chat-button";
import { useIsMobile } from "@/hooks/use-mobile";
import LocaleLink from "@/lib/i18n/locale-link";
import { useLocaleRouter } from "@/lib/utils.client";
import type { CmsContentHeader } from "../cms/schema";
import { CartButton } from "../shopping-cart/components/cart-button";
import { UserAccountInHeader } from "../users/account/user-account";
import { WishWrapper } from "../wish-list/wish-button";
import { MobileSearchDrawer } from "./components/mobile-search-drawer";
export function MobileNav(t0) {
  const $ = _c(52);
  const {
    navItems
  } = t0;
  const {
    t
  } = useTranslation();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useLocaleRouter();
  let t1;
  bb0: {
    if (!pathname) {
      t1 = false;
      break bb0;
    }
    let t2;
    if ($[0] !== pathname) {
      t2 = pathname.split("/").filter(Boolean);
      $[0] = pathname;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const segments = t2;
    t1 = segments.length <= 1;
  }
  const isHomePage = t1;
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isJoinCommunityOpen, setIsJoinCommunityOpen] = useState(false);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["link", "largeImageTopBottom", "mediumImageTopBottom", "smallImageLeftRight", "textOnly"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const validTypes = t2;
  let t3;
  if ($[3] !== navItems) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = item => validTypes.includes(item.type);
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = navItems.slice(0, 12).filter(t4);
    $[3] = navItems;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const limitedNavItems = t3;
  let t4;
  let t5;
  if ($[6] !== open) {
    t4 = () => {
      if (open) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return _temp;
    };
    t5 = [open];
    $[6] = open;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const searchBarHeight = window.homeSearchBarHeight || 60;
        setIsScrolled(scrollTop > searchBarHeight);
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t7 = [];
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[11] !== pathname) {
    t8 = () => {
      if (pathname) {
        setOpen(false);
        setIsJoinCommunityOpen(false);
      }
    };
    t9 = [pathname];
    $[11] = pathname;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  useEffect(t8, t9);
  const isMobile = useIsMobile();
  if (!isMobile) {
    return null;
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setIsJoinCommunityOpen(true);
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const handleJoinCommunity = t10;
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setOpen(true);
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const handleOpenSidebar = t11;
  let t12;
  if ($[16] !== isHomePage || $[17] !== isScrolled || $[18] !== t) {
    t12 = (isHomePage ? isScrolled : true) && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: "easeInOut"
    }} onClick={() => setIsSearchOpen(true)} className="cursor-pointer pl-[4px] sm:pl-[8px]"><Image src={SearchIcon} alt={t("header.search")} width={24} height={24} className="size-5.5" /></motion.div>;
    $[16] = isHomePage;
    $[17] = isScrolled;
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <AnimatePresence>{t12}</AnimatePresence>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== isHomePage || $[23] !== router) {
    t14 = () => {
      if (isHomePage) {
        window.location.reload();
      } else {
        router.push("/");
      }
    };
    $[22] = isHomePage;
    $[23] = router;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MobileLogo className="w-20 h-6" />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14) {
    t16 = <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"><div onClick={t14} className="cursor-pointer">{t15}</div></div>;
    $[26] = t14;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <CartButton />;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = require("@/assets/images/common/Hamburger-icon.png");
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t) {
    t19 = t("header.openMenu");
    $[30] = t;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t19) {
    t20 = <div className="ml-auto flex items-center">{t17}<div className="ml-[6px] flex size-5.5 items-center justify-center p-0 transition-colors duration-150" onClick={handleOpenSidebar}><Image src={t18} alt={t19} width={24} height={24} className="size-5.5" unoptimized={true} /></div></div>;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t13 || $[35] !== t16 || $[36] !== t20) {
    t21 = <div className="sticky top-0 z-50  bg-white px-3"><div className="relative flex items-center justify-between py-2.5">{t13}{t16}{t20}</div></div>;
    $[34] = t13;
    $[35] = t16;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== isSearchOpen) {
    t22 = isSearchOpen && <MobileSearchDrawer open={isSearchOpen} onClose={() => setIsSearchOpen(false)} />;
    $[38] = isSearchOpen;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== limitedNavItems || $[41] !== open || $[42] !== pathname || $[43] !== searchParams) {
    t23 = open && typeof document !== "undefined" && createPortal(<AnimatePresence><motion.div key="drawer-overlay" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-200"><div className="fixed inset-0 bg-black opacity-30" onClick={() => setOpen(false)} /><motion.div key="drawer" initial={{
          x: "100%"
        }} animate={{
          x: 0
        }} exit={{
          x: "100%"
        }} transition={{
          duration: 0.3,
          ease: "easeOut"
        }} className="fixed top-0 right-0 z-201 flex h-full w-screen max-w-[100vw] flex-col bg-white shadow-lg" style={{
          boxShadow: "-2px 0 8px rgba(0,0,0,0.08)"
        }}><div className="sticky top-0 z-10 flex items-center justify-between border-b border-[#eee] bg-white pt-3 pr-3 pb-3 pl-4"><UserAccountInHeader showLabel={true} onClick={e => {
              const redirectPath = searchParams?.get("redirect");
              if (pathname?.includes("/account") || redirectPath?.includes("/account")) {
                e.preventDefault();
                setOpen(false);
              }
            }} /><div className="flex size-5.5 items-center justify-center" onClick={() => setOpen(false)}><CloseMobileNavIcon className="size-5.5" /></div></div><div className="flex-1 overflow-y-auto"><MobileMenuList navItems={limitedNavItems} /></div><div className="flex w-full flex-row items-center justify-around border-t border-[#eee] bg-[#f5f5f5] px-4 py-3"><WishWrapper onSamePathClick={() => setOpen(false)}><div className="flex cursor-pointer flex-col items-center justify-center p-2"><MobileNavWishListIcon className="size-6" /></div></WishWrapper><QuickChatWrapper><div className="flex cursor-pointer flex-col items-center justify-center p-2"><MobileNavContactUsIcon className="size-6" /></div></QuickChatWrapper><LocaleLink href={"/store-list" as any} className="flex cursor-pointer flex-col items-center justify-center p-2" onClick={() => setOpen(false)}><MobileNavFindAStoreIcon className="size-6" /></LocaleLink><div className="flex cursor-pointer flex-col items-center justify-center p-2" onClick={handleJoinCommunity}><MobileNavEmailUsIcon className="size-6" /></div></div></motion.div></motion.div></AnimatePresence>, document.body) as any;
    $[40] = limitedNavItems;
    $[41] = open;
    $[42] = pathname;
    $[43] = searchParams;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== isJoinCommunityOpen) {
    t24 = isJoinCommunityOpen && typeof document !== "undefined" && createPortal(<JoinCommunityModal open={isJoinCommunityOpen} onClose={() => setIsJoinCommunityOpen(false)} />, document.body) as any;
    $[45] = isJoinCommunityOpen;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t21 || $[48] !== t22 || $[49] !== t23 || $[50] !== t24) {
    t25 = <div className="md:hidden">{t21}{t22}{t23}{t24}</div>;
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  return t25;
}

// 新增：加入社区弹窗组件
function _temp() {
  document.body.style.overflow = "";
}
function JoinCommunityModal(t0) {
  const $ = _c(60);
  const {
    open,
    onClose
  } = t0;
  const [email, setEmail] = useState("");
  const [submitted] = useState(false);
  const inputRef = useRef(null);
  const {
    t
  } = useTranslation();
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (open && inputRef.current) {
        inputRef.current.focus();
      }
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== email || $[4] !== onClose || $[5] !== t) {
    t3 = e => {
      e.preventDefault();
      if (!email.includes("@")) {
        toast.error(t("footer.subscribe.invalidEmail"));
        return;
      }
      (window as any)?.quickChatApi?.setContactProperties({
        email
      });
      toast.success(t("footer.subscribe.success"));
      setEmail("");
      onClose();
    };
    $[3] = email;
    $[4] = onClose;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSubmit = t3;
  let t4;
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0
    };
    t5 = {
      opacity: 1
    };
    t6 = {
      opacity: 0
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      background: "rgba(0,0,0,0.3)"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t10;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      scale: 0.9,
      opacity: 0
    };
    t9 = {
      scale: 1,
      opacity: 1
    };
    t10 = {
      scale: 0.9,
      opacity: 0
    };
    $[11] = t10;
    $[12] = t8;
    $[13] = t9;
  } else {
    t10 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] !== t) {
    t11 = t("common.close");
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <title>{t11}</title>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <path d="M18 6L6 18" stroke="#888" strokeWidth="2" strokeLinecap="round" />;
    t14 = <path d="M6 6L18 18" stroke="#888" strokeWidth="2" strokeLinecap="round" />;
    $[18] = t13;
    $[19] = t14;
  } else {
    t13 = $[18];
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t12) {
    t15 = <svg width="24" height="24" viewBox="0 0 24 24">{t12}{t13}{t14}</svg>;
    $[20] = t12;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== onClose || $[23] !== t15) {
    t16 = <div className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" onClick={onClose}>{t15}</div>;
    $[22] = onClose;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t) {
    t17 = t("header.joinCommunity");
    $[25] = t;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17) {
    t18 = <div className="mb-2 text-center text-xl font-bold">{t17}</div>;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t) {
    t19 = t("header.joinCommunityDesc");
    $[29] = t;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t19) {
    t20 = <div className="mb-4 text-center text-base text-gray-700">{t19}</div>;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t) {
    t21 = t("header.enterEmail");
    $[33] = t;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_0 => setEmail(e_0.target.value);
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== email || $[37] !== t21) {
    t23 = <input ref={inputRef} type="email" className="mb-4 w-full rounded border border-gray-300 px-3 py-2 focus:border-black focus:outline-none" placeholder={t21} value={email} onChange={t22} required={true} />;
    $[36] = email;
    $[37] = t21;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== submitted || $[40] !== t) {
    t24 = submitted ? t("common.submitted") : t("common.submit");
    $[39] = submitted;
    $[40] = t;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== submitted || $[43] !== t24) {
    t25 = <button type="submit" className="mb-2 w-full rounded bg-black py-2 font-bold text-white" disabled={submitted}>{t24}</button>;
    $[42] = submitted;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t) {
    t26 = t("common.cancel");
    $[45] = t;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== onClose || $[48] !== t26) {
    t27 = <button type="button" className="w-full rounded border border-gray-300 py-2 font-bold" onClick={onClose}>{t26}</button>;
    $[47] = onClose;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== handleSubmit || $[51] !== t23 || $[52] !== t25 || $[53] !== t27) {
    t28 = <form onSubmit={handleSubmit}>{t23}{t25}{t27}</form>;
    $[50] = handleSubmit;
    $[51] = t23;
    $[52] = t25;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t16 || $[56] !== t18 || $[57] !== t20 || $[58] !== t28) {
    t29 = <motion.div initial={t4} animate={t5} exit={t6} className="fixed inset-0 z-202 flex items-center justify-center" style={t7}><motion.div initial={t8} animate={t9} exit={t10} className="relative w-[90vw] max-w-[400px] rounded bg-white p-6 shadow-lg">{t16}{t18}{t20}{t28}</motion.div></motion.div>;
    $[55] = t16;
    $[56] = t18;
    $[57] = t20;
    $[58] = t28;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  return t29;
}